import { put, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import * as actions from '../store/options.actions'
import { IOptions } from '../../../common/common.types'

export function* setAirwayEttSizeUnitOptions() {
  try {
    const entity: IOptions = [
      {
        id: 0,
        name: 'mm',
      },
      {
        id: 1,
        name: 'cm',
      },
      {
        id: 2,
        name: 'fr',
      },
    ]

    yield put(actions.setAirEttSizeUnitOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`setAirwayEttSizeUnitOptions() error: ${e}`))
  }
}
export function* setAirwayEttSizeUnitOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setAirwayEttSizeUnitOptions)
}
